import { Component, OnInit } from '@angular/core';
import { LMSDataService } from 'lms-api';
import { Course } from 'lms-api';
import { TitleWrapperService } from '../_services/title-wrapper.service';
import { LmsUserService } from 'lms-api';

@Component({
  selector: 'app-courses-all',
  templateUrl: './courses-all.component.html',
  styleUrls: ['./courses-all.component.scss']
})
export class CoursesAllComponent implements OnInit {
  courses: Course[];
  constructor(
    private lmsDataService: LMSDataService,
    public lmsUserService: LmsUserService,
    private titleService: TitleWrapperService) { }

  ngOnInit() {
    this.titleService.SetTitle('Massage Courses | Continuing Education Massage Therapy | ABMP', true);
    this.lmsDataService.OnCoursesUpdated.subscribe(courses => {
      this.courses = courses;
    });
  }
}